import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/Components/shadcn/button';
import UIStrings from '@/Utils/UIStrings';
import { useClientsOverviewContext } from '../contexts/ClientsOverviewContext';
import { ClientFormValues } from './Client';
import ClientFormDialog from './ClientForm/ClientFormDialog';

const ClientAddButton = () => {
    const [open, setOpen] = useState(false);
    const { createClient } = useClientsOverviewContext();

    const onSubmit = async (client: ClientFormValues) => {
        await createClient(client);
        setOpen(false);
    };

    return (
        <>
            <Button onClick={() => setOpen(true)} variant="default">
                <Plus data-icon="inline-start" className="size-4" />
                {UIStrings.CreateCompany}
            </Button>
            <ClientFormDialog open={open} onClose={() => setOpen(false)} onSubmit={onSubmit} />
        </>
    );
};

export default ClientAddButton;
